import React from 'react';
import { Search } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-183">
      {label && <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-184">
          {label}
        </label>}
      <div className="relative" data-id="element-185">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400" data-id="element-186">
            {icon}
          </div>}
        <input className={`
            block w-full rounded-md border-slate-300 shadow-sm 
            focus:border-[#0D9488] focus:ring-[#0D9488] sm:text-sm
            disabled:bg-slate-50 disabled:text-slate-500
            placeholder:text-slate-400
            ${icon ? 'pl-10' : 'pl-3'}
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-slate-200'}
            ${className}
          `} {...props} data-id="element-187" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-188">{error}</p>}
    </div>;
}